import { Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class ContentPackManager extends ManagerBase {
	constructor () {
		super("contentPackManager");
		this.remoteClassName = "content-pack";
	}

	async checkShortCode (shortCode) {
		const rd = NousCore.api.createRequest({item: { shortCode } });
		const requestedAction = "check-short-code";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});

	}
}

const contentPackManager = new ContentPackManager();

Shark.registerController(contentPackManager);

export default contentPackManager;
